import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, of } from 'rxjs';

import { environment } from '../environments/environment';
import { Configuration } from '../models/configuration.model';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private getConfiguration(): Observable<Configuration> {
    return of({
      linearStepper: environment.linearStepper,
      environmentLink: environment.environmentLink,
      bffURL: environment.bffURL,
      awsURL: environment.awsURL,
      aircraftsURL: 'aircrafts',
      enrollmentURL: 'enrollment',
      regionURL: 'region',
      partyURL: 'party',
      fileURL: 'file',
      fileUploadURL: 'file/upload',
      bffFileURL: 'file',
      apiClientId: environment.apiClientId,
      apiBffClientId: environment.apiBffClientId,
      surveyURL: environment.surveyURL,
    });
  }
  configuration = toSignal(this.getConfiguration(), {
    initialValue: {
      linearStepper: true,
      environmentLink: '',
      bffURL: '',
      awsURL: '',
      aircraftsURL: '',
      enrollmentURL: '',
      regionURL: '',
      partyURL: '',
      fileURL: '',
      fileUploadURL: '',
      bffFileURL: '',
      apiClientId: '',
      apiBffClientId: '',
      surveyURL: '',
    } as Configuration,
  });
}
